import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-alpha-common';
import { Card } from '@oneaudi/unified-web-alpha-components';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const PackageContentSection = styled.section`
	display: flex;
	flex-direction: column;
	p {
		color: ${(props) => props.theme.sys.color.text.headline.default};
	}
`;

export const PackageContentList = styled.ul`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
`;

export const PackageContentStyle = styled(Card)`
	position: relative;
	display: flex;
	flex-direction: column;

	.item-name {
		color: ${(props) => props.theme.sys.color.text.headline.default};
	}

	.wrapper {
		width: 100%;

		${breakPoints({
			'768': `
				flex-direction: row-reverse;
			`,
		})}
	}

	img {
		aspect-ratio: 16 / 9;
		width: 100%;
		flex-shrink: 0;
		object-fit: cover;

		${breakPoints({
			'768': `
			width: 208px;
		`,
		})}
	}

	.image-not-available {
		aspect-ratio: 16 / 9;
		width: 100%;
		flex-shrink: 0;
		background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));

		${breakPoints({
			'768': `
			width: 208px;
		`,
		})}
	}

	button {
		align-self: flex-start;
		align-items: center;
	}
`;
